'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _currenciesTools = require('./currenciesTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    AmountFormat: {
        displayName: 'AmountFormat'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/AmountFormat/index.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var AmountFormat = _wrapComponent('AmountFormat')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(AmountFormat, _Component);

    function AmountFormat() {
        (0, _classCallCheck3.default)(this, AmountFormat);
        return (0, _possibleConstructorReturn3.default)(this, (AmountFormat.__proto__ || (0, _getPrototypeOf2.default)(AmountFormat)).apply(this, arguments));
    }

    (0, _createClass3.default)(AmountFormat, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$amount = _props.amount,
                amount = _props$amount.amount,
                id = _props$amount.id,
                currency_id = _props$amount.currency_id,
                wrapProps = _props.wrapProps,
                wrapTag = _props.wrapTag;


            var flag = (0, _currenciesTools.getFlagByCurrency)(currency_id);

            var props = (0, _extends3.default)({}, wrapProps, {
                id: id
            });

            return _react3.default.createElement(
                'wrapTag',
                props,
                amount,
                flag
            );
        }
    }]);
    return AmountFormat;
}(_react2.Component), _class.propTypes = {
    amount: _react2.PropTypes.shape({
        id: _react2.PropTypes.number,
        amount: _react2.PropTypes.oneOfType([_react2.PropTypes.string, _react2.PropTypes.number]),
        currency: _react2.PropTypes.string,
        currency_id: _react2.PropTypes.number
    }).isRequired,
    wrapTag: _react2.PropTypes.string,
    wrapProps: _react2.PropTypes.object
}, _class.defaultProps = {
    wrapTag: 'div',
    wrapProps: {}
}, _temp));

exports.default = AmountFormat;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AmountFormat/index.jsx
// module id = 1602
// module chunks = 0